import translateResource from "./TranslateResource.json";
import LocalStorageKey from "../enums/LocalStorageKey";

/**
 * 객체와 문자열 경로를 받아 해당 값을 반환하는 함수
 * @param {string} path - "common.title"과 같은 문자열 경로
 * @param {Array<string|number>} [args] - 템플릿 문자열에 삽입할 값 배열 (옵션)
 * @returns {*} - 경로에 해당하는 값 (없으면 path)
 */
function Translate(path, args) {
    path = path + `.${localStorage.getItem(LocalStorageKey.language) || "en"}`;
    const keys = path.split(".");

    const templateString = keys.reduce((acc, key) => {
        return acc?.[key];
    }, translateResource);

    if (templateString === undefined) {
        return path;
    }

    if (!args || !Array.isArray(args) || args.length === 0) {
        return templateString;
    }

    let finalString = templateString;

    args.forEach((value, index) => {
        const placeholder = `\\$\\{${index}\\}`;

        const regex = new RegExp(placeholder, "g");

        finalString = finalString.replace(regex, value);
    });

    return finalString;
}

export default Translate;
